window.addEventListener('load', function () {
  var modalTriggers = document.querySelectorAll('.modal-trigger');
  var modals = document.querySelectorAll('.modal-wrapper');
  var modalCloseTriggers = document.querySelectorAll('.close-modal');
  var modalOverlay = document.querySelector('.modal-overlay');

  modalTriggers.forEach(modalTrigger => {
    modalTrigger.addEventListener('click', function () {
      var modalTarget = modalTrigger.getAttribute('data-modal-target');

      toggleModal(modalTarget);
    });
  });

  modalCloseTriggers.forEach(modalCloseTrigger => {
    modalCloseTrigger.addEventListener('click', function () {
      var modalWrapper = this.closest('.modal-wrapper');

      closeModal(modalWrapper);
    });
  })

  if(modalOverlay) {
    modalOverlay.addEventListener('click', function () {
      var modalWrapper = this.closest('.modal-wrapper');
  
      closeModal(modalWrapper);
    });
  }

  function toggleModal(modalToShow) {
    modals.forEach(modal => {
      var modalData = modal.getAttribute('data-modal');

      if(modalData == modalToShow) {
        modal.querySelector('.modal-overlay').classList.toggle('modal-open');
        modal.querySelector('.modal-card').classList.toggle('modal-open');
      }
    })
  }

  function closeModal(modalToClose) {
    modalToClose.querySelector('.modal-overlay').classList.remove('modal-open');
    modalToClose.querySelector('.modal-card').classList.remove('modal-open');
  }
});